import { render, staticRenderFns } from "./FormCupones.vue?vue&type=template&id=f1790564&scoped=true"
import script from "./FormCupones.vue?vue&type=script&lang=js"
export * from "./FormCupones.vue?vue&type=script&lang=js"
import style0 from "./FormCupones.vue?vue&type=style&index=0&id=f1790564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1790564",
  null
  
)

export default component.exports